import autocompleteCompanyInput from './autocompleteCompanyInput';

const input = document.querySelector('.company-name-input input[type=text]');
const inputId = document.querySelector('.gform_body input[type=hidden]:first-of-type');

if (input && inputId) {

  input.parentNode.style.position = 'relative'

  autocompleteCompanyInput(input, inputId);

  console.log(input)

  input.addEventListener('keydown', function(e) {
    if( ( e.keyCode >= 48 && e.keyCode <= 90 ) || e.keyCode == 8 || e.keyCode == 46 ) {
      inputId.value = '';
    }
  });
}

